(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  var KLAVIYO_REVISION = '2026-04-15';
  var REQUEST_TIMEOUT_MS = 8000;
  var BOUND_FLAG = 'klaviyoBound';
  var configWarnFired = false;

  function warnConfigOnce(formEl) {
    if (configWarnFired) return;
    configWarnFired = true;
    console.warn('[klaviyo-subscribe] Missing companyId or listId on form', formEl);
  }

  function getDataset(formEl, key, fallback) {
    var v = formEl.dataset[key];
    return (v && v.length) ? v : fallback;
  }

  function setStatus(el, message, role) {
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    if (role) el.setAttribute('data-state', role);
  }

  function clearStatus(successEl, errorEl) {
    setStatus(successEl, '', '');
    setStatus(errorEl, '', '');
  }

  function lockForm(formEl, submitBtn, locked) {
    if (locked) {
      formEl.setAttribute('aria-busy', 'true');
      if (submitBtn) submitBtn.disabled = true;
    } else {
      formEl.removeAttribute('aria-busy');
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  function getPreferredLanguage() {
    // theme.liquid zet <html lang="{{ request.locale.iso_code }}"> (nl/en);
    // "en-GB"-achtige codes terugbrengen tot de kale taalcode.
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang ? lang.split('-')[0] : '';
  }

  function buildPayload(email, listId, customSource) {
    var profileAttributes = {
      email: email,
      subscriptions: {
        email: { marketing: { consent: 'SUBSCRIBED' } }
      }
    };
    // De EN/NL-splits in de Klaviyo-flows lezen properties.preferred_language
    // ("en" -> Engelse tak, anders Nederlands). Zonder dit veld valt iedereen in NL.
    var lang = getPreferredLanguage();
    if (lang) profileAttributes.properties = { preferred_language: lang };
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource || 'Newsletter',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
  }

  function submitToKlaviyo(companyId, payload) {
    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT_MS);

    var url = KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId);

    return fetch(url, {
      method: 'POST',
      headers: {
        'accept': 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload),
      signal: controller.signal
    }).then(function (res) {
      clearTimeout(timeoutId);
      return res;
    }).catch(function (err) {
      clearTimeout(timeoutId);
      throw err;
    });
  }

  function bindForm(formEl) {
    if (!formEl || formEl.dataset[BOUND_FLAG] === 'true') return;
    formEl.dataset[BOUND_FLAG] = 'true';

    var submitBtn = formEl.querySelector('button[type="submit"], input[type="submit"]');
    var emailInput = formEl.querySelector('input[type="email"]');
    var honeypot = formEl.querySelector('input[name="company"]');
    var consentCheckbox = formEl.querySelector('input[type="checkbox"][data-klaviyo-consent]');
    var successEl = formEl.querySelector('[data-klaviyo-success]');
    var errorEl = formEl.querySelector('[data-klaviyo-error]');

    var consentField = consentCheckbox ? consentCheckbox.closest('.newsletter-form__consent') : null;
    // Keep the button clickable so an unchecked consent gives clear feedback on submit.
    if (consentCheckbox) {
      consentCheckbox.addEventListener('change', function () {
        if (consentCheckbox.checked) {
          if (consentField) consentField.classList.remove('is-error');
          consentCheckbox.removeAttribute('aria-invalid');
        }
      });
    }
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        emailInput.classList.remove('is-error');
        emailInput.removeAttribute('aria-invalid');
      });
    }

    formEl.addEventListener('submit', function (event) {
      event.preventDefault();
      clearStatus(successEl, errorEl);

      var companyId = (getDataset(formEl, 'companyId', '') || '').trim();
      var listId = (getDataset(formEl, 'listId', '') || '').trim();
      // promoEl.dataset.variant (gezet door popup.js: v2_card/v2_sheet/ab_direct/ab_scratch)
      // is de bron van waarheid voor de arm -- valt terug op de statische data-source
      // voor forms buiten de popup (bv. footer-newsletter, geen <promo-popup>-ouder).
      var promoEl = formEl.closest('promo-popup');
      var variant = promoEl && promoEl.dataset.variant;
      var customSource = variant ? ('Newsletter popup ' + variant) : getDataset(formEl, 'source', 'Newsletter');
      var successMessage = getDataset(formEl, 'successMessage', 'Check your inbox to confirm your subscription.');
      var errorMessage4xx = getDataset(formEl, 'error_4xx', getDataset(formEl, 'errorMessage', 'Something went wrong. Please try again.'));
      var errorMessage5xx = getDataset(formEl, 'error_5xx', getDataset(formEl, 'errorMessage', 'Something went wrong on our side. Try again in a moment.'));
      var configError = getDataset(formEl, 'configError', 'Newsletter is being configured.');

      if (honeypot && honeypot.value) {
        setStatus(successEl, successMessage, 'success');
        if (submitBtn) submitBtn.disabled = true;
        return;
      }

      if (consentCheckbox && !consentCheckbox.checked) {
        if (consentField) consentField.classList.add('is-error');
        consentCheckbox.setAttribute('aria-invalid', 'true');
        consentCheckbox.focus();
        return;
      }

      if (!formEl.checkValidity()) {
        if (emailInput && !emailInput.checkValidity()) {
          emailInput.classList.add('is-error');
          emailInput.setAttribute('aria-invalid', 'true');
        }
        formEl.reportValidity();
        return;
      }

      if (!companyId || !listId) {
        warnConfigOnce(formEl);
        setStatus(errorEl, configError, 'error');
        return;
      }

      if (!emailInput || !emailInput.value) return;
      var email = emailInput.value.trim();

      lockForm(formEl, submitBtn, true);

      submitToKlaviyo(companyId, buildPayload(email, listId, customSource))
        .then(function (res) {
          if (res.status === 202) {
            setStatus(successEl, successMessage, 'success');
            formEl.reset();
            if (consentCheckbox) consentCheckbox.checked = false;
            formEl.removeAttribute('aria-busy');
            if (submitBtn) submitBtn.disabled = true;
            // switch the popup to its success state (footer forms have no .popup -> no-op)
            var successPopup = formEl.closest('.popup');
            if (successPopup) {
              successPopup.classList.add('popup-success');
              if ((window.hotConsent?.analytics() === true || window.hotConsent?.marketing() === true) && typeof window.gtag === 'function') window.gtag('event', 'popup_signup', { popup: variant || 'v2_card', in_app: !!(promoEl && promoEl.isInApp) });
              // popup.js zet de langdurige ingeschreven-cookie en verbergt het teaser-tabje
              if (promoEl && typeof promoEl.onSignupSuccess === 'function') promoEl.onSignupSuccess();
            }
            return;
          }
          if (res.status >= 400 && res.status < 500) {
            setStatus(errorEl, errorMessage4xx, 'error');
          } else {
            setStatus(errorEl, errorMessage5xx, 'error');
          }
          lockForm(formEl, submitBtn, false);
        })
        .catch(function () {
          setStatus(errorEl, errorMessage5xx, 'error');
          lockForm(formEl, submitBtn, false);
        });
    });
  }

  function bindAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-klaviyo-form]').forEach(bindForm);
  }

  window.KlaviyoSubscribe = {
    init: function (formEl) {
      if (formEl) {
        bindForm(formEl);
      } else {
        bindAll();
      }
    },
    bindAll: bindAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindAll(); });
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target || document);
  });
})();
